import './component.scss'

import './images/section_line.svg'
import './images/icon_checkbox.svg'
import './images/icon_house.svg'
import './images/icon_robot.svg'
import './images/icon_speech_bubble.svg'
import './images/site_top_sp_icon_quote.svg'

document.addEventListener('DOMContentLoaded', () => {
  document.getElementsByClassName('js-ChannelIO-openWorkflow').forEach(element => {
    element.addEventListener('click', () => {
      if (typeof window.ChannelIO === 'function') {
        window.ChannelIO('openWorkflow', element.dataset.channelId)
      } else {
        // ChannelIOが埋め込まれていない環境で正しく呼ばれていることを確認するためconsole.logを仕込む
        console.log(`call ChannelIO openWorkflow ${element.dataset.channelId}`)
      }
    })
  })
})
